define(['jquery'], function ($) {
    "use strict";
    return {
        // Returns a function, that, as long as it continues to be invoked, will not
        // be triggered. The function will be called after it stops being called for
        // N milliseconds. If `immediate` is passed, trigger the function on the
        // leading edge, instead of the trailing.
        debounce: function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this, args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };

                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        },
        menuScroller: function () {
            $("#nav-main a, .right-header-button a").click(function (evt) {
                var scrollTarget = $(this).attr('href');
                if (scrollTarget.charAt(0) !== '/') {
                    if ($(scrollTarget).length > 0) {
                        evt.preventDefault();
                        $([document.documentElement, document.body]).stop().animate({
                            scrollTop: $(scrollTarget).offset().top - 100
                        }, 2000);
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            });
        },
        initHeader: function() {
            $('.navbar-toggler').on('click', function() {
                if ($(this).hasClass('collapsed')) {
                    $(this).addClass('uncollapsed');
                } else {
                    $(this).removeClass('uncollapsed');
                }
            });
            $('.search-link-wrapper a').on('click', function(evt) {
                evt.preventDefault();
                $('.search-box-wrapper').toggleClass('open');
            });
            $('.dropdown-toggle.nav-link').on('click', function(evt) {
                evt.preventDefault();
                $('.search-box-wrapper').removeClass('open');
            });
        },
        initBreadcrumb: function() {
            if ($('.jumbotron.with-image .image-top').length > 0) {
                let $breadcrumb = $('.breadcrumb-text').html();
                $('.jumbotron.with-image .image-top .teaser-text-wrapper').prepend($breadcrumb);
            }
            if ($('.jumbotron.product-detail .product-detail-header-teaser').length > 0) {
                let $breadcrumb = $('.breadcrumb-text').html();
                $('.jumbotron.product-detail .product-detail-header-teaser .teaser-text-wrapper').prepend($breadcrumb);
            }
        },
        initBackgroundImages: function() {
            let $backgroundContainers = $('.frame-background-image');
            $backgroundContainers.each(function () {
                let $backgroundImage = $(this).find('.image-embed-item');
                let $backgroundImageWidth = $backgroundImage.width();
                let $containerWidth = $(this).children().width();
                if ($backgroundImageWidth > $containerWidth) {
                    let imageMargin = (($backgroundImageWidth - $containerWidth)/2)*-1 + 'px';
                    $backgroundImage.css('marginLeft', imageMargin);
                }
            });
        },
        initForm: function () {
            let $fileFields = $('.tx-powermail').find('.powermail_file');
            $fileFields.each(function () {
                $(this).on('change', function () {
                    if ($(this).get(0).files.length !== 0) {
                        $(this).after('<a href="#" class="remove-file" data-remove="' + $(this).attr('id') + '"></a>');
                    }
                });
            });

            $("form").on("click", ".custom-file-upload", function (evt) {
                if ($(this).hasClass('file-chosen')) {
                    evt.preventDefault();
                }
            });

            $("form").on("change", ".powermail_fieldwrap_type_file input", function () {
                let filename = $(this).val().replace(/.*(\/|\\)/, '');
                let filenameLength = 14;
                if ($(window).width() > 1199) {
                    filenameLength = 30;
                }
                if (filename.length > filenameLength) {
                    filename = filename.substr(0, filenameLength);
                    filename += '...';
                }
                $(this).siblings(".custom-file-upload").addClass('file-chosen');
                $(this).siblings(".custom-file-upload").text(filename);
            });

            $('.tx-powermail').on('click', '.remove-file', function (evt) {
                evt.preventDefault();
                let $resetEl = $('#' + $(this).data('remove'));
                let $customLabel = $resetEl.siblings('.custom-file-upload');
                $customLabel.text($customLabel.data('default'));
                $customLabel.removeClass('file-chosen');
                $resetEl.wrap('<form>').closest('form').get(0).reset();
                $resetEl.unwrap();
                $(this).remove();
            });
/*
            window.Parsley.on('field:error', function () {
                $(this.$element).parents('.powermail_fieldwrap').addClass('error');
            });
            window.Parsley.on('field:success', function () {
                $(this.$element).parents('.powermail_fieldwrap').removeClass('error');
            });*/
        }
    };
});
